import { IndustryTemplate } from '@/components';
import { poolSpaContent } from '@/data/industries/poolspa';

export function PoolSpaPage() {
  return <IndustryTemplate content={poolSpaContent} />;
}
